// extracted by mini-css-extract-plugin
export default {"text":"ProblemTestcaseProgress_text__ZoHeu","textLight":"ProblemTestcaseProgress_textLight__eGrMM","textDark":"ProblemTestcaseProgress_textDark__qLvF4"};